import { API } from 'src/utils/interceptor'

/** Starts a run, then asks for one chunk at a time so progress can update. */
export const startAndPollVenueGroupRun = async ({
  groupId,
  action,
  payload,
  onProgress,
}) => {
  const started = await API.post('api2', `venue-groups/${groupId}/runs`, {
    body: { action, payload: payload || {} },
  })
  const runId = started?.data?.runId
  if (!runId) throw new Error('The run did not start.')

  let summary = null
  for (let step = 0; step < 40; step += 1) {
    await API.post('api2', `venue-groups/${groupId}/runs/${runId}/process`, {
      body: {},
    })
    const next = await API.get('api2', `venue-groups/${groupId}/runs/${runId}`)
    summary = next?.data
    onProgress?.(summary)
    if (summary?.status === 'finished') return summary
  }
  throw new Error('The run did not finish.')
}
